import React, { CSSProperties } from 'react';

import Box from '@mui/material/Box';
import { TitleComponent } from './TitleComponent';
import styles from '../styles/MenuContent.module.css';

interface TitleWrapperProps {
  title?: string;
  children: JSX.Element;
  style?: CSSProperties;
}
export const TitleWrapper = (props: TitleWrapperProps) => {
  return (
    <div className={styles.pageBody} style={props.style}>
      <Box m={props.title ? 2 : ''}>
        {props.title && <TitleComponent title={props.title} />}
        <Box m={2}>
          <div>{props.children}</div>
        </Box>
      </Box>
    </div>
  );
};
